import { AxiosBookings, orgId, userId } from "../apiConfig";

import { appendQueryParams } from "../../utilities/urlUtils";

export const quoteAndDraftApiFactory = {
  $_createQuote(payload) {
    let url = `/shippings/quote?userId=${userId()}`;
    return AxiosBookings.post(url, payload);
  },
  $_getQuoteAndDraft(params) {
    let url = `/billing-collection/all-transaction/${orgId()}${appendQueryParams(
      params
    )}`;
    return AxiosBookings.get(url);
  },
  // $_getNewQuoteAndDraft(params) {
  //   const url = `/billing-collection/all-transaction/${userId()}${appendQueryParams(
  //     params
  //   )}`;
  //   return AxiosBookings.get(url);
  // },
  $_getQuoteAndDraftCustomer(params) {
    let url = `/billing-collection/all-transaction/${userId()}${appendQueryParams(
      params
    )}`;
    return AxiosBookings.get(url);
  },
  $_deleteQuoteAndDraftCustomer(shippingId) {
    const url = `/shippings/${shippingId}`;
    return AxiosBookings.delete(url);
  },
};
